<template>

<form id="userForm" class="mx-auto col-12" @submit.prevent>
  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('batch') }">
      <label for="batch">{{ $t('batch') }}</label>
      <input
        type="text"
        id="batch"
        name="batch"
        class="form-control"
        :placeholder="$t('ph_batch')"
        v-model="component.batch"
        v-validate="'required'"
        @input="upper('batch')"
      >

      <small v-show="errors.has('batch')" class="form-text text-muted">
        {{ errors.first('batch') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('itemType') }">
      <label for="itemType">{{ $t('itemType') }}</label>
      <input
        type="text"
        id="itemType"
        name="itemType"
        class="form-control"
        :placeholder="$t('ph_itemType')"
        v-model="component.itemType"
        v-validate="'required'"
        @input="upper('itemType')"
      >

      <small v-show="errors.has('itemType')" class="form-text text-muted">
        {{ errors.first('itemType') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('provider') }">
      <label for="provider">{{ $t('provider') }}</label>
      <input
        type="text"
        id="provider"
        name="provider"
        class="form-control"
        :placeholder="$t('ph_provider')"
        v-model="component.provider"
        v-validate="'required'"
        @input="upper('provider')"
      >

      <small v-show="errors.has('provider')" class="form-text text-muted">
        {{ errors.first('provider') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('nf') }">
      <label for="nf">{{ $t('nf') }}</label>
      <input
        type="text"
        id="nf"
        name="nf"
        class="form-control"
        :placeholder="$t('ph_nf')"
        v-model="component.nf"
        v-validate="'required'"
        @input="upper('nf')"
      >

      <small v-show="errors.has('nf')" class="form-text text-muted">
        {{ errors.first('nf') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('totalValueNF') }">
      <label for="totalValueNF">{{ $t('totalValueNF') }}</label>
      <CurrencyInput
        v-model="component.totalValueNF"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('totalValueNF')" class="form-text text-muted">
        {{ errors.first('totalValueNF') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('amountItems') }">
      <label for="amountItems">{{ $t('amountItems') }}</label>
      <input
        type="number"
        id="amountItems"
        name="amountItems"
        class="form-control"
        :placeholder="$t('ph_amountItems')"
        v-model="component.amountItems"
        v-validate="'required'"
      >

      <small v-show="errors.has('amountItems')" class="form-text text-muted">
        {{ errors.first('amountItems') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('purchase_date') }">
      <label for="purchase_date">{{ $t('purchase_date') }}</label>
      <input
        type="date"
        id="purchase_date"
        name="purchase_date"
        class="form-control"
        v-model="component.purchaseDate"
        v-validate="'required'"
      />

      <small v-show="errors.has('purchase_date')" class="form-text text-muted">
        {{ errors.first('purchase_date') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('purchase_value') }">
      <label for="purchase_value">{{ $t('purchase_value') }} (unitário)</label>
      <CurrencyInput
        v-model="component.purchaseValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('purchase_value')" class="form-text text-muted">
        {{ errors.first('purchase_value') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('warranty_date') }">
      <label for="warranty_date">{{ $t('warranty_date') }}</label>
      <input
        type="date"
        id="warranty_date"
        name="warranty_date"
        class="form-control"
        v-model="component.warrantyDate"
        v-validate="'required'"
      />

      <small v-show="errors.has('warranty_date')" class="form-text text-muted">
        {{ errors.first('warranty_date') }}
      </small>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'ComponentForm',
  components: {
    LoaderButton,
    Combobox
  },

  props: {
    component: {
      type: Object,
      default: () => ({
        id           : undefined,
        batch        : '',
        itemType     : undefined,
        provider     : '',
        nf           : '',
        totalValueNF : 0,
        amountItems  : '',
        purchaseValue: 0,
        purchaseDate : '',
        warrantyDate : ''
      })
    }
  },

  methods: {
    ...mapActions('component', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.component

      const promise = id
        ? this.edit({ id, data: this.component })
        : this.create(this.component)

      const result = await promise
      
      if (result) {
        this.$router.push({ name: 'listcomponents' })
      }
    },

    upper(attribute) {
      this.component[attribute] = this.component[attribute].toUpperCase()
    }
  },

  destroyed () {
    this.cleanState()
  }
}
</script>